import React, { useContext } from "react";
import { Page, View, Text, StyleSheet, Image as PdfImage, Font } from "@react-pdf/renderer";
import { Document, pdf } from "@react-pdf/renderer";
import Html from "react-pdf-html";
import { cleanSpanKeepColorAndFontSize, cleanStyleKeepColorAndFontSize, convettSignatureDatesToGMTLocal, formatNumber, isNullUndefined, isNullUndefinedOrEmpty, markStrikethrough, normalizeInlineColorAndSize, qrToPng, stripItalicAndUnderline } from "../Helpers";
import { getExportBookPdfMessages } from "../../services/sBook/message-log.service";
import { saveAs } from "file-saver";
import moment from "moment";
import logoBook from "../../images/export_pdf/SG3Book.png";
import segRegular from "../../fonts/segoeui.ttf";
import segItalic from "../../fonts/segoeuii.ttf";
import segBold    from "../../fonts/segoeuib.ttf";
import { cloneDeep } from "lodash-es";
import { t } from "i18next";
import { sortRepliesBySendDate } from "../bookReplies";

// Herramienta de diagnóstico SOLO para bisectar en consola del navegador el HTML real de un mensaje
// que rompe el export a PDF, sin necesidad de reexportar el libro completo cada vez.
// Uso en DevTools (con la app ya cargada):
//   __exportDebugTestBody(`<p>...pegar aquí el messageBody real, o un pedazo, tal cual...</p>`)
// Devuelve true/OK si esa porción de HTML renderiza bien, o loguea el error real si revienta.
// Permite ir cortando el texto a la mitad (bisección) hasta acotar la frase exacta que rompe Yoga.
export const debugTestMessageBodyPdf = async (rawHtml) => {
    try {
        Font.register({
            family: "segoeui",
            fonts: [
                { src: segRegular, fontWeight: 400, format: "truetype" },
                { src: segItalic, fontWeight: 400, fontStyle: "italic" },
                { src: segBold, fontWeight: 700 },
            ],
        });
        const cleaned = cleanSpanKeepColorAndFontSize(cleanStyleKeepColorAndFontSize(normalizeInlineColorAndSize(markStrikethrough(stripItalicAndUnderline(rawHtml.replace(/\n$/, ""))))));
        const doc = (
            <Document>
                <Page style={{ padding: 20 }}>
                    <View style={{ width: "100%" }}>
                        <Html stylesheet={{ p: { fontSize: 11, fontFamily: "segoeui" } }}>{cleaned}</Html>
                    </View>
                </Page>
            </Document>
        );
        await pdf(doc).toBlob();
        console.log("%c[__exportDebugTestBody] OK, esta porción de texto NO revienta.", "color: green; font-weight: bold");
        return true;
    }
    catch (error) {
        console.error("[__exportDebugTestBody] *** ESTA PORCIÓN DE TEXTO REVIENTA ***", error);
        return false;
    }
};

if (typeof window !== "undefined") {
    window.__exportDebugTestBody = debugTestMessageBodyPdf;
}

export const ExportBookOrMessageToPdf = async (t, bookObject, partyMemberId, messageId, messageCode, clientName, isBookExport, userName) => {
   
    const styles = StyleSheet.create({
        body:        { paddingTop: 80, paddingBottom: 60, paddingHorizontal: 40 },
        glosaryBody: { paddingTop: 40, paddingBottom: 40, paddingHorizontal: 40 },
            
        header: {
            headerBlock: {
                //main:     { paddingTop: 80, paddingBottom: 60  },
                logos:    { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 12, position: "absolute", top: -50, left: -130, right: -130, marginBottom: 20, flexDirection: "row", justifyContent: "space-between", color: 'grey', alignItems: "center" },
                text:     { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 12, position: "absolute", top: -10, left: 0, right: 0, marginBottom: 60, paddingBottom: 60, flexDirection: "row", justifyContent: "space-between", color: 'grey', alignItems: "center" },
                subtext:  { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 12, marginBottom: 10, paddingBottom: 10, flexDirection: "row", alignItems: "center" },
            },
                logoClient:   { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 12, fontWeight: 700, margin: "auto", marginTop: 70, marginBottom: 50, width: 140, height: 40 },
                logoBook:     { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 12, fontWeight: 700, margin: "auto", marginTop: 70, marginBottom: 50, width: 140, height: 40 },
                title:        { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 12, fontWeight: 700, margin: "auto", marginTop: 80, marginBottom: 40 },
        },
        footer: {
            title:            { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 10, position: "absolute", bottom: 40, left: 40, right: 40, textAlign: "center" },
            subTitle:         { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 10, position: "absolute", bottom: 25, left: 40, right: 40, textAlign: "center" },
            pageNumber:       { position: "absolute", bottom: 25, right: 40, fontSize: 10 }
        },
        contract: {
            header:           { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, position: "absolute", top: 20, left: 40, right: 40, flexDirection: "row", justifyContent: "space-between", alignItems: "center" },
                fullTitle:    { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, fontWeight: "bold", flexDirection: "row", gap: 20 },
                title:        { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 16, fontWeight: 700, margin: "auto", marginTop: 90, marginBottom: 30, textDecoration: "underline" },
                contractBlock:{ lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, marginBottom: 20, marginTop: 90 },
                colFull:      { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, flexDirection: "row", gap: 20 },
                value:        { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, fontWeight: "bold" },
                label:        { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, width: 250 },
        },
    
        index: {
            indexBlock:       { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, marginBottom: 20, marginTop: 90 },
            col:              { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, flexDirection: "row", gap: 200 },
            label:            { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, width: 250 },
            value:            { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, fontWeight: "bold" },
        },   

        section: {   
            sectionBlock:     { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, marginBottom: 10, marginTop: 100 },
            row:              { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, flexDirection: "row", marginBottom: 3, margin: "auto" },
            label:            { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, fontWeight: "bold" },
        },   

        message: {   
            mainBlock:        { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, marginBottom: 10, marginTop: 50 },
            messageBlock:     { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, marginBottom: 10, marginTop: 10 },
            bodyBlock:        { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, marginBottom: 10, marginTop: 10, flexDirection: "row", gap: 20  },
            row:              { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, flexDirection: "row", padding: 4, border: "1px solid #000", textAlign: "center" },
            rowbody:          {  width: '100%' , lineHeight: 1.4, fontFamily: "segoeui", fontSize: 10, flexDirection: "row", padding: 4, border: "1px solid #000", textAlign: "center" },
            col:              { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, flex: 1, textAlign: "center" },
            twoCols:          { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, flexDirection: "row", gap: 8 },
            label:            { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, flex: 1, fontWeight: "bold", textAlign: "center" },
            value:            { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, flex: 1, textAlign: "left" },
    
            infoCol:          { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, flex: 1 },
            infoLabel:        { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, width: 130, fontWeight: "bold", textAlign: "left" },
            infoValue:        { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, flex: 1, textAlign: "left" }, 
     
            sectionRow:       { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, flexDirection: "row", marginBottom: 3, margin: "auto" },
            sectionLabel:     { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, fontWeight: "bold" },
     
            subjectBlock:     { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, marginBottom: 20, marginTop: 20, flexDirection: "row", gap: 20  },
            subjectRow:       { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, flexDirection: "row", padding: 4, border: "1px solid #000" },
            subjectCol:       { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, flex: 1,textAlign: "center" },
            subjectCol1:      { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, flex: 1,textAlign: "center" },
            subjectCol2:      { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, flex: 3,textAlign: "center" },
            subjectLabel:     { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, fontWeight: "bold", textAlign: "left" },
            attachmentLabel:  { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, flex: 3, fontWeight: "bold", textAlign: "left" },
            subjectValue:     { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, flex: 1, textAlign: "left" },
            attachmentCol1:   { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, flex: 1,textAlign: "center" },
            attachmentCol2:   { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, flex: 3,textAlign: "center" },
            attachmentRow:    { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, flexDirection: "row", textAlign: "left", height: "auto" },
        },
    
        glosary: {
            title:            { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 13, fontWeight: 700, margin: "auto", marginTop: 50, marginBottom: 30, textDecoration: "underline" },
            item:             { lineHeight: 1.2, fontFamily: "segoeui", fontSize: 11, flexDirection: "row", marginBottom: 10 },
            term:             { lineHeight: 1.2, fontFamily: "segoeui", fontSize: 11, width: 200, fontWeight: "bold" },
            def:              { lineHeight: 1.2, fontFamily: "segoeui", fontSize: 11, flex: 1 }
        },    
        
        qr: {    
            img: 		      { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, width: 120, height: 120 },
            value:            { lineHeight: 1.4, fontFamily: "segoeui", fontSize: 11, marginLeft: 50 },
        },
    });
    
    Font.register({
        family: "segoeui",
        fonts: [
            { src: segRegular, fontWeight: 400, format: "truetype" },
            { src: segItalic,  fontWeight: 400, fontStyle: "italic" },
            { src: segBold,    fontWeight: 700 }
        ]
    });
  
    const indexData = [
        { label: "Portada", value: "Pag X" },
        { label: "Índice", value: "Pag X" },
        { label: "Resumen de comunicaciones del libro por sección", value: "Pag X" },
        { label: "Sección 1: 'Arranque del contrato' - 2 comunicaciones", value: "Pag X" },
        { label: "Sección 2: 'Control de ejecución del servicio' - 1 comunicación", value: "Pag X" },
        { label: "Glosario", value: "Pag X" }
    ];
  
    const PageBookData = (props) => {
            return  <Page style={styles.body}>
                        <HeaderView showMiddleText={false} book={props.book} clientName={props.clientName} />
                        <View style={styles.contract.header} fixed>
                            <Text style={styles.contract.title}>{props.book.bookName}</Text>
                        </View>
                        <View style={styles.contract.contractBlock}>
                            <View style={styles.contract.colFull}>
                                <Text style={styles.contract.label}>{t('data-lang-lbl-main')}</Text>
                                <Text style={styles.contract.value}>{!isNullUndefined(props.book.mainBook) ? (props.book.mainBook === true ? t('data-lang-lbl-yes') : t('data-lang-lbl-no') ) : t('data-lang-lbl-notapply') }</Text>
                            </View>
                            <View style={styles.contract.colFull}>
                                <Text style={styles.contract.label}>{t('data-lang-lbl-relatedconcept')}</Text>
                                <Text style={styles.contract.value}>{!isNullUndefined(props.book.relatedConceptType) ? t(props.book.relatedConceptType) : t('data-lang-lbl-notapply') }</Text>
                            </View>
                            <View style={styles.contract.colFull}>
                                <Text style={styles.contract.label}>{t('data-lang-lbl-contractcode')}</Text>
                                <Text style={styles.contract.value}>{props.book.relatedConceptCode}</Text>
                            </View>
                            <View style={styles.contract.colFull}>
                                <Text style={styles.contract.label}>{t('data-lang-lbl-contractname')}</Text>
                                <Text style={styles.contract.value}>{props.book.relatedConceptName}</Text>
                            </View>
                            <View style={styles.contract.colFull}>
                                <Text style={styles.contract.label}>{t('data-lang-lbl-startdate')}</Text>
                                <Text style={styles.contract.value}>{moment(props.book.startDate).format('DD/MM/YYYY')}</Text>
                            </View>
                            <View style={styles.contract.colFull}>
                                <Text style={styles.contract.label}>{t('data-lang-lbl-enddate')}</Text>
                                <Text style={styles.contract.value}>{moment(props.book.endDate).format('DD/MM/YYYY')}</Text>
                            </View>
                            <View style={styles.contract.colFull}>
                                <Text style={styles.contract.label}>{t('data-lang-lbl-partemandante')}</Text>
                                <Text style={styles.contract.value}>{props.book.legalEntityBuyerName}</Text>
                            </View>
                            <View style={styles.contract.colFull}>
                                <Text style={styles.contract.label}>{t('data-lang-lbl-areamandante')}</Text>
                                <Text style={styles.contract.value}>{props.book.businessUnitName}</Text>
                            </View>
                            <View style={styles.contract.colFull}>
                                <Text style={styles.contract.label}>{t('data-lang-lbl-partecontratista')}</Text>
                                <Text style={styles.contract.value}>{props.book.legalEntitySupplierName}</Text>
                            </View>
                        </View>
                        {
                            props.isBookExport &&
                            <View style={styles.contract.contractBlock}>
                                <View style={styles.contract.fullTitle}>
                                    <Text style={styles.contract.label}>{t('data-lang-lbl-communicationsstatus')}</Text>
                                    <Text style={styles.contract.value}>{t('data-lang-lbl-messagecount')}</Text>
                                </View>
                                <View style={styles.contract.colFull}>
                                    <Text style={styles.contract.label}>{t('data-lang-lbl-total')}</Text>
                                    <Text style={styles.contract.value}>{props.book.messagesCount}</Text>
                                </View>
                                <View style={styles.contract.colFull}>
                                    <Text style={styles.contract.label}>{t('data-lang-lbl-sendedmessages')}</Text>
                                    <Text style={styles.contract.value}>{props.book.messagesSendCount}</Text>
                                </View>
                                <View style={styles.contract.colFull}>
                                    <Text style={styles.contract.label}>{t('data-lang-lbl-receivedmessages')}</Text>
                                    <Text style={styles.contract.value}>{props.book.messagesReceivedCount}</Text>
                                </View>
                            </View>
                        }
                        <FooterView currentUser={props.book.userFullname} currentDate={Date.now()} />
                    </Page>
    };
    
    const PageIndexData = (props) => {
        return  <Page size="A4"wrap>
                    <HeaderView showMiddleText={true} text={t('data-lang-lbl-index')} book={props.book} clientName={props.clientName} />
                    <View style={styles.index.indexBlock}>
                        {indexData.map((r, i) => (
                            <View key={i} style={styles.index.col}>
                                <Text style={styles.index.label}>{r.label}</Text>
                                <Text style={styles.index.value}>{r.value}</Text>
                            </View>
                        ))}
                    </View>
                    <FooterView currentUser={props.book.userFullname} currentDate={Date.now()} />
                </Page>
    };
    
    const PageSectionData = (props) => {
        return  <>
                    {
                        props.book.l_sections.map((section, idx) => (
                            <>
                                {
                                    props.isBookExport &&
                                    <Page key={idx} style={styles.body}>
                                        <HeaderView showMiddleText={false} book={props.book} clientName={props.clientName} />
                                        <View style={styles.section.sectionBlock}>
                                            <View style={styles.section.row}>
                                                <Text style={styles.section.label}>{section.seccionName}</Text>
                                            </View>
                                                <View style={styles.section.row}>
                                                <Text style={styles.section.label}>{section.messagesCount} {t('data-lang-lbl-totalsectionmessages')}</Text>
                                            </View>
                                        </View>
                                        <FooterView currentUser={props.book.userFullname} currentDate={Date.now()} />
                                    </Page>
                                }
                                <PageMessageData pngs={props.pngs} book={props.book} isBookExport={props.isBookExport} section={section} index={idx} userName={props.book.userFullname} />
                            </>
                        ))
                    }
                </>
    };

    // Todas las respuestas enviadas del mensaje, una por línea y en orden de envío
    // (filas "Código relacionado" y "Fecha respuesta real").
    const answeredByLines = (item_message_l_is_answered_by, formatReply) => {
        const replies = sortRepliesBySendDate(item_message_l_is_answered_by);
        return <Text style={styles.message.infoValue}>{replies.length > 0 ? replies.map(formatReply).join('\n') : t('data-lang-lbl-notapply')}</Text>
    }

    const replyCode = (reply) => reply.messageCode;

    const replySendDate = (reply) => {
        const date = reply.messageSendDate ?? reply.messageDate;
        return !isNullUndefined(date) ? moment(date).format('DD/MM/YYYY') : t('data-lang-lbl-notapply');
    }

    // Diagnóstico: detecta caracteres de control, sustitutos UTF-16 sueltos o "non-characters" en un
    // string, SIN exponer el contenido del mensaje (solo posición y código hex de cada carácter sospechoso).
    const scanSuspiciousChars = (str, messageId, messageCode, fieldName) => {
        if (!str) return;
        const found = [];
        for (let i = 0; i < str.length; i++) {
            const code = str.charCodeAt(i);
            const isControl = code < 0x20 && code !== 0x09 && code !== 0x0a && code !== 0x0d;
            const isUnpairedHigh = code >= 0xd800 && code <= 0xdbff && (i + 1 >= str.length || str.charCodeAt(i + 1) < 0xdc00 || str.charCodeAt(i + 1) > 0xdfff);
            const isUnpairedLow = code >= 0xdc00 && code <= 0xdfff && (i === 0 || str.charCodeAt(i - 1) < 0xd800 || str.charCodeAt(i - 1) > 0xdbff);
            const isNoncharacter = (code >= 0xfdd0 && code <= 0xfdef) || code === 0xfffe || code === 0xffff || code === 0xfffd;
            if (isControl || isUnpairedHigh || isUnpairedLow || isNoncharacter) {
                found.push({ index: i, code: '0x' + code.toString(16) });
            }
        }
        if (found.length > 0) {
            console.warn(`[ExportBookOrMessageToPdf] Caracteres sospechosos en "${fieldName}" del mensaje id=${messageId} (code: ${messageCode}):`, found);
        }
    };

    // Normaliza artefactos de formato que en la práctica rompen el layout de react-pdf-html/Yoga
    // (confirmado con el mensaje id=699974 del book 2271): párrafos vacíos y cadenas largas de <br/>
    // consecutivos (típico de texto pegado desde Word/Outlook). Se colapsan/eliminan ANTES de renderizar.
    const normalizeExcessiveBreaks = (html) => {
        return html
            .replace(/(?:\s*<br\s*\/?>\s*){3,}/gi, '<br /><br />')
            .replace(/<p>(?:\s|&nbsp;)*<\/p>/gi, '');
    };

    // Aísla el saneo de HTML de un mensaje puntual: si el HTML de UN mensaje viene corrupto,
    // se registra en consola cuál fue (id/código) y se cae a texto plano en vez de abortar todo el PDF.
    const cleanMessageBodyForPdf = (rawBody, messageId, messageCode) => {
        scanSuspiciousChars(rawBody, messageId, messageCode, 'messageBody');
        try {
            const normalized = normalizeExcessiveBreaks(rawBody.replace(/\n$/, ""));
            return cleanSpanKeepColorAndFontSize(cleanStyleKeepColorAndFontSize(normalizeInlineColorAndSize(markStrikethrough(stripItalicAndUnderline(normalized)))));
        }
        catch (bodyError) {
            console.error(`[ExportBookOrMessageToPdf] El HTML del mensaje id=${messageId} (code: ${messageCode}) no se pudo procesar para el PDF, se muestra como texto plano.`, bodyError);
            return rawBody.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
        }
    };

    const PageMessageData = (props) => {
        return  <>
                    {props.section.l_items.map((item, idx) => (
                        <>
                            <Page key={idx} style={styles.body}>
                                <HeaderView showMiddleText={false} book={props.book} clientName={props.clientName} />
                                <View style={styles.message.mainBlock}>
                                    <View>
                                        <View style={styles.message.sectionRow}>
                                            <Text style={styles.message.sectionLabel}>{props.section.seccionName}</Text>
                                        </View>
                                    </View>
                                    <View style={styles.message.messageBlock}>
                                        {
                                            props.isBookExport &&
                                            <View style={styles.message.sectionRow}>
                                                <Text>{t('data-lang-boxname-communication')} [{item.iMessage}/{props.section.l_items.length}]</Text>
                                            </View>
                                        }
                                        <View style={styles.message.twoCols}>
                                            <View style={styles.message.infoCol}>
                                                <View style={styles.message.row}>
                                                    <Text style={styles.message.infoLabel}>{t('data-lang-lbl-messagecode')}:</Text>
                                                    <Text style={styles.message.infoValue}>{item.item_message.messageCode}</Text>
                                                </View>
                                                <View style={styles.message.row}>
                                                    <Text style={styles.message.infoLabel}>{t('data-lang-lbl-senderpartyname')}:</Text>
                                                    <Text style={styles.message.infoValue}>{item.item_message.senderPartyName}</Text>
                                                </View>
                                                <View style={styles.message.row}>
                                                    <Text style={styles.message.infoLabel}>{t('data-lang-lbl-senderusername')}:</Text>
                                                    <Text style={styles.message.infoValue}>{item.item_message.senderUsername}</Text>
                                                </View>
                                                <View style={styles.message.row}>
                                                    <Text style={styles.message.infoLabel}>{t('data-lang-lbl-messagedate')}:</Text>
                                                    <Text style={styles.message.infoValue}>{!isNullUndefined(item.item_message.messageDate) ? moment(item.item_message.messageDate).format('DD/MM/YYYY') : t('data-lang-lbl-notapply')}</Text>
                                                </View>
                                            </View>
                                            <View style={styles.message.infoCol}>
                                                <View style={styles.message.row}>
                                                    <Text style={styles.message.infoLabel}>{t('data-lang-lbl-deadlinedate')}:</Text>
                                                    <Text style={styles.message.infoValue}>{!isNullUndefined(item.item_message.deadlineDate) ? moment(item.item_message.deadlineDate).format('DD/MM/YYYY') : t('data-lang-lbl-notapply')}</Text>
                                                </View>
                                                <View style={styles.message.row}>
                                                    <Text style={styles.message.infoLabel}>{t('data-lang-lbl-relatedmessagecode')}:</Text>
                                                    {
                                                        answeredByLines(item.item_message_l_is_answered_by, replyCode)
                                                    }
                                                </View>
                                                <View style={styles.message.row}>
                                                    <Text style={styles.message.infoLabel}>{t('data-lang-lbl-receiversparty2')}:</Text>
                                                    <Text style={styles.message.infoValue}>{item.item_message.receiversParty}</Text>
                                                </View>
                                                <View style={styles.message.row}>
                                                    <Text style={styles.message.infoLabel}>{t('data-lang-lbl-actualresponsedate')}:</Text>
                                                    {
                                                        answeredByLines(item.item_message_l_is_answered_by, replySendDate)
                                                    }
                                                </View>
                                                <View style={styles.message.row}>
                                                    <Text style={styles.message.infoLabel}>{t('data-lang-lbl-messagestatus')}:</Text>
                                                    <Text style={styles.message.infoValue}>{t(item.item_message.status === 'data-lang-lbl-sendedmessages' ? 'data-lang-lbl-sendedmessage' : ((!isNullUndefinedOrEmpty(item.item_message.status) && item.item_message.status.indexOf('data-lang') !== -1 && item.item_message.status.indexOf(' ') !== -1) ? item.item_message.status.split(' ')[0] : (item.item_message.status ?? '')))}</Text>
                                                </View>
                                            </View>
                                        </View>
                                    </View>
                                </View>
                                <View style={styles.message.subjectBlock}>
                                    <View style={styles.message.subjectCol}>
                                        <View style={styles.message.subjectRow}>
                                            <View style={styles.message.subjectCol1}>
                                                <Text style={styles.message.subjectLabel}>{t('data-lang-lbl-subject')}</Text>
                                            </View>
                                            <View style={styles.message.subjectCol2}>
                                                <Text style={styles.message.subjectValue}>{item.item_message.messageTitle}</Text>
                                            </View>
                                        </View>
                                        <View style={styles.message.subjectRow}>
                                            <View style={styles.message.attachmentCol1}>
                                                <View style={styles.message.attachmentRow}>
                                                    <Text style={styles.message.subjectLabel}>{`${t('data-lang-lbl-attachment')}: ${item.item_message.nAttacheds}`}</Text>
                                                </View>
                                            </View>
                                            <View style={styles.message.attachmentCol2}>
                                                    {(item.l_documents ?? []).map((document, idx2) =>
                                                        <View key={idx2} style={styles.message.attachmentRow}>
                                                            <Text key={idx2} style={styles.message.subjectValue}>{`(${document.code}) ${document.name}`}</Text>
                                                        </View>
                                                    )}
                                            </View>
                                        </View>
                                    </View>
                                </View>
                                <View style={styles.message.bodyBlock}>
                                    <View style={styles.message.col}>
                                        <View style={styles.message.row}>
                                            <Text style={styles.message.label}>{`${t('data-lang-lbl-message')}`}</Text>
                                        </View>
                                        <View style={styles.message.rowbody}>
                                            <View style={{ width: '100%' }}>
                                                <Html stylesheet={{'span[data-strike="1"]': { textDecoration: 'line-through' }, p: { fontSize: 11, marginBottom: 4, textAlign: "left" }, ol: {fontSize: 11}, ul: {fontSize: 11}, li: {fontSize: 11} }}>{!isNullUndefined(item.item_message.messageBody) ? cleanMessageBodyForPdf(item.item_message.messageBody, item.item_message.id, item.item_message.messageCode) : t('data-lang-lbl-nodata')}</Html>
                                            </View>
                                        </View>
                                    </View>
                                </View>
                                <View style={styles.message.bodyBlock}>
                                    <View style={styles.message.col}>
                                        <View style={styles.message.row}>
                                            <Text style={styles.message.label}>{t('data-lang-sbmessageevent-type-signature')}</Text>
                                        </View>
                                        <View style={styles.message.row}>
                                            {
                                                !isNullUndefinedOrEmpty(item.item_message.messageQR) &&
                                                <>
                                                    <Text style={styles.message.value}>{convettSignatureDatesToGMTLocal(item.item_message.messageQR)}</Text>
                                                    <View style={styles.qr.value}>{
                                                        !isNullUndefined(item.item_message.messageQR) ?
                                                            (!isNullUndefined(props.pngs.find(x => x.messageId === item.item_message.id)) && !isNullUndefined(props.pngs.find(x => x.messageId === item.item_message.id).image)) ?
                                                                <PdfImage src={props.pngs.find(x => x.messageId === item.item_message.id).image} style={styles.qr.img} /> :
                                                                    <Text>{t('data-lang-lbl-nodata')}</Text> :
                                                                        <Text>{t('data-lang-lbl-nodata')}</Text>
                                                                        
                                                        }
                                                    </View>
                                                </>
                                            }
                                            {
                                                isNullUndefinedOrEmpty(item.item_message.messageQR) &&
                                                <Text>{t('data-lang-lbl-nodata')}</Text>
                                            }
                                        </View>
                                    </View>
                                </View>
                                <FooterView currentUser={props.userName} currentDate={Date.now()} />
                            </Page>
                        </>
                    ))}
                </>
    };
  
    const PageGlosaryData = (props) => {
        return  <Page style={styles.glosaryBody}>
                    <HeaderView book={props.book} clientName={props.clientName} />
                    <View>
                        <Text style={styles.glosary.title}>{t('data-lang-lbl-glosary')}</Text>
                        <View style={styles.glosary.item}>
                            <Text style={styles.glosary.term}>{t('data-lang-lbl-pdf-sendedmessages')}:</Text>
                            <Text style={styles.glosary.def}>{t('data-lang-lbl-pdf-sendedmessages-info')}</Text>
                        </View>
                        <View style={styles.glosary.item}>
                            <Text style={styles.glosary.term}>{t('data-lang-lbl-pdf-receivedmessages')}:</Text>
                            <Text style={styles.glosary.def}>{t('data-lang-lbl-pdf-receivedmessages-info')}</Text>
                        </View>
                        <View style={styles.glosary.item}>
                            <Text style={styles.glosary.term}>{t('data-lang-lbl-pdf-unreadedmessages')}:</Text>
                            <Text style={styles.glosary.def}>{t('data-lang-lbl-pdf-unreadedmessages-info')}</Text>
                        </View>
                        <View style={styles.glosary.item}>
                            <Text style={styles.glosary.term}>{t('data-lang-lbl-pdf-expiredmessages')}:</Text>
                            <Text style={styles.glosary.def}>{t('data-lang-lbl-pdf-expiredmessages-info')}</Text>
                        </View>
                        <View style={styles.glosary.item}>
                            <Text style={styles.glosary.term}>{t('data-lang-lbl-pdf-pendingwaiting')}:</Text>
                            <Text style={styles.glosary.def}>{t('data-lang-lbl-pdf-pendingwaiting-info')}</Text>
                        </View>
                        <View style={styles.glosary.item}>
                            <Text style={styles.glosary.term}>{t('data-lang-lbl-pdf-expiredwaiting')}:</Text>
                            <Text style={styles.glosary.def}>{t('data-lang-lbl-pdf-expiredwaiting-info')}</Text>
                        </View>
                        <View style={styles.glosary.item}>
                            <Text style={styles.glosary.term}>{t('data-lang-lbl-pdf-mainbook')}:</Text>
                            <Text style={styles.glosary.def}>{t('data-lang-lbl-pdf-mainbook-info')}</Text>
                        </View>
                        <View style={styles.glosary.item}>
                            <Text style={styles.glosary.term}>{t('data-lang-lbl-pdf-auxiliar')}:</Text>
                            <Text style={styles.glosary.def}>{t('data-lang-lbl-pdf-auxiliar-info')}</Text>
                        </View>
                        <View style={styles.glosary.item}>
                            <Text style={styles.glosary.term}>{t('data-lang-lbl-pdf-relatedconcept')}:</Text>
                            <Text style={styles.glosary.def}>{t('data-lang-lbl-pdf-relatedconcept-info')}</Text>
                        </View>
                        <View style={styles.glosary.item}>
                            <Text style={styles.glosary.term}>{t('data-lang-lbl-pdf-buyerparty')}:</Text>
                            <Text style={styles.glosary.def}>{t('data-lang-lbl-pdf-buyerparty-info')}</Text>
                        </View>
                        <View style={styles.glosary.item}>
                            <Text style={styles.glosary.term}>{t('data-lang-lbl-pdf-supplierparty')}:</Text>
                            <Text style={styles.glosary.def}>{t('data-lang-lbl-pdf-supplierparty-info')}</Text>
                        </View>
                        <View style={styles.glosary.item}>
                            <Text style={styles.glosary.term}>{t('data-lang-lbl-pdf-messagecode')}:</Text>
                            <Text style={styles.glosary.def}>{t('data-lang-lbl-pdf-messagecode-info')}</Text>
                        </View>
                        <View style={styles.glosary.item}>
                            <Text style={styles.glosary.term}>{t('data-lang-lbl-pdf-relatedmessagecode')}:</Text>
                            <Text style={styles.glosary.def}>{t('data-lang-lbl-pdf-relatedmessagecode-info')}</Text>
                        </View>
                        <View style={styles.glosary.item}>
                            <Text style={styles.glosary.term}>{t('data-lang-lbl-pdf-deadlinedate')}:</Text>
                            <Text style={styles.glosary.def}>{t('data-lang-lbl-pdf-deadlinedate-info')}</Text>
                        </View>
                        <View style={styles.glosary.item}>
                            <Text style={styles.glosary.term}>{t('data-lang-lbl-notapply')}:</Text>
                            <Text style={styles.glosary.def}>{t('data-lang-lbl-notapply-full')}</Text>
                        </View>
                    </View>
                    <FooterView currentUser={props.book.userFullname} currentDate={Date.now()} />
                </Page>
    };
    
    const HeaderView = (props) => {
        return  <> 
                    <View style={styles.header.headerBlock.logos} fixed>
                        {
                            !isNullUndefined(props.book) && !isNullUndefinedOrEmpty(props.book.logoImageBase) ?
                            <PdfImage style={styles.header.logoClient} src={`data:image/png;base64,${props.book.logoImageBase}`} /> :
                            <Text style={styles.header.logoClient}>{props.clientName}</Text>
                        }
                        <PdfImage style={styles.header.logoBook} src={logoBook} />
                    </View>
                    <View style={styles.header.headerBlock.text} fixed>
                        {
                            props.showMiddleText &&
                            <Text style={styles.header.title}>{props.text}</Text>
                        }
                    </View>
                </>
    };
    
    const FooterView = (props) => {
        return  <>
                    <View style={styles.footer.title} fixed>
                        <Text>{t('data-lang-lbl-extractioninformation')}:</Text>
                    </View>
                    <View style={styles.footer.subTitle} fixed>
                        <Text>{t('data-lang-lbl-notcontrolledcopy')} - {moment(props.currentDate).format("DD-MM-YYYY")}, {props.currentUser}</Text>
                    </View>
                    <View style={styles.footer.pageNumber}>
                        <Text render={({ pageNumber }) => `${pageNumber}`} />
                    </View>
                </>
    };
  



    try {
        const serviceResponse = await getExportBookPdfMessages(bookObject.id, partyMemberId, messageId);
        const response = serviceResponse.data;
        if (response.succeeded) {
            const dataToExport = response.data;
            const items = response.data.l_sections?.flatMap(sec => sec.l_items) ?? []

            // Cada QR se genera de forma aislada: si UN mensaje falla al generar su QR, se registra
            // en consola cuál fue (id/código) y se continúa con el resto en vez de abortar todo el export.
            const pngs = await Promise.all(
                items.map(async (it) => {
                    const currentMessageId = it.item_message.id;
                    const qrData = it.item_message.messageQR;
                    scanSuspiciousChars(qrData, currentMessageId, it.item_message.messageCode, 'messageQR');
                    try {
                        const image = !isNullUndefinedOrEmpty(qrData) ? await qrToPng(convettSignatureDatesToGMTLocal(qrData), styles.qr.width) : null;
                        return { messageId: currentMessageId, image };
                    }
                    catch (qrError) {
                        console.error(`[ExportBookOrMessageToPdf] Fallo al generar el QR del mensaje id=${currentMessageId} (code: ${it.item_message.messageCode}), se omite el QR de este mensaje.`, qrError);
                        return { messageId: currentMessageId, image: null };
                    }
                })
            );
            const aux_blob = await pdf(<Document>
                <PageBookData    book={dataToExport} clientName={clientName} isBookExport={isBookExport} />
                <PageSectionData book={dataToExport} clientName={clientName} pngs={pngs} isBookExport={isBookExport}/>
                <PageGlosaryData book={dataToExport} clientName={clientName} />
           </Document>).toBlob();


            saveAs(aux_blob, messageId !== 0 ? `Export-Book-${bookObject.bookCode}-${messageCode}.pdf` : `Export-Book-${bookObject.bookCode}.pdf`);
        }
        else {
            console.error(`[ExportBookOrMessageToPdf] El backend respondió succeeded=false para el book_id=${bookObject.id}${messageId ? `, message_id=${messageId}` : ''}.`, response);
        }
    }
    catch (error) {
        console.error(`[ExportBookOrMessageToPdf] Fallo la exportación a PDF del book_id=${bookObject.id}${messageId ? `, message_id=${messageId}` : ''}.`, error);
    }
};

export const ExportPowerBiToPdf = async (singleRecord, gridRows, chartUris, data_roles, data_contract, clientName) => {

    const styles = StyleSheet.create({
        page: { padding: 14, fontSize: 9, color: "#111" },              // A4 landscape
        title: { fontSize: 16, marginBottom: 12, textAlign: "center"},
        h1: { fontSize: 16, marginBottom: 12 },
        h2: { fontSize: 13, marginBottom: 12 },
        rowTitle: { flexDirection: "row", justifyContent: "center", marginBottom: 4 },

        hSection: { fontSize: 11, fontWeight: 700, marginTop: 10, marginBottom: 6 },

        // “Tarjeta” genérica
        card: {
            border: "1px solid #ddd",
            borderRadius: 6,
            padding: 8,
            marginBottom: 8,
            backgroundColor: "#fff",
        },
        // “Sombra” simple (simulada)
        cardShadow: { borderBottomColor: "#e5e5e5", borderRightColor: "#e5e5e5" },

        // Fila de 2 columnas (gráficos)
        row: { flexDirection: "row", gap: 8 },
        col: { flexGrow: 1, flexBasis: "50%" },

        // Header de tarjeta (título)
        cardHeader: { fontSize: 10, fontWeight: 700, marginBottom: 6, color: "#4a4a4a" },

        // Imagen de gráfico
        //chartImg: { width: "100%", height: 210, objectFit: "contain" },
        chartImage: { width: 400, height: "auto" },
        chartsRow: { flexDirection: "row", justifyContent: "space-between", marginVertical: 10 },

        // Separador sutil
        hr: { height: 1, backgroundColor: "#eee", marginVertical: 6 },

        footer: { position: "absolute", bottom: 14, left: 0, right: 0, textAlign: "center", fontSize: 9, color: "#666" },
    });

    const stylesChart = StyleSheet.create({
        chartsRow: { flexDirection: "row", gap: 8, marginTop: 8 },
        chartCol: { flex: 1 },
        chartTitle: { fontSize: 10, fontWeight: 700, marginBottom: 6 },
        chartImage: { width: "100%", height: 210, objectFit: "contain" },
    });

    const pdfStyles = {
        // Tabla de un registro (dos filas)
        ".single-record": { width: "100%", borderCollapse: "collapse", fontSize: 9 },
        ".single-record th": {
            border: "1px solid #d9d9d9", backgroundColor: "#f5f6f8",
            padding: 5, textAlign: "center", fontWeight: 700
        },
        ".single-record td": { border: "1px solid #d9d9d9", padding: 5, textAlign: "left" },

        // Fila secundaria (aceleración / % avances)
        ".single-record.secondary th": { backgroundColor: "#fafafa" },

        // Grilla KPI (periodos + subheaders)
        ".grid-kpi": { width: "100%", borderCollapse: "collapse", fontSize: 8.5 },
        ".grid-kpi th, .grid-kpi td": { border: "1px solid #cfcfcf", padding: 3 },
        ".grid-kpi thead tr:nth-child(1) th": {
            backgroundColor: "#eef0f3", textAlign: "center", fontWeight: 700
        },
        ".grid-kpi thead tr:nth-child(2) th": { backgroundColor: "#f7f8fa", textAlign: "center" },

        ".th-fixed": { width: 160, fontWeight: 700, backgroundColor: "#f7f7f7" },
        ".td-name": { },
        ".td-num": { textAlign: "right" },
        ".td-logro": { textAlign: "right" },

        ".td-group": { fontWeight: 700, backgroundColor: "#fbfbfb" },

        // semáforos
        ".dot": { display: "inline-block", width: 6, height: 6, borderRadius: 3, marginRight: 4 },
        ".dot.green": { backgroundColor: "#2ca02c" },
        ".dot.orange": { backgroundColor: "#ff9900" },
        ".dot.red": { backgroundColor: "#d62728" },
        ".dot.v": { backgroundColor: "#2ca02c" },
        ".dot.a": { backgroundColor: "#ff9900" },
        ".dot.r": { backgroundColor: "#d62728" },
        ".text-r": {  textAlign: "right" },
        ".text-c": {  textAlign: "center" },
        ".d-flex": { flexDirection: "row" }
    };

    const getColumngroups = (data) => {
        const serieTimeColumns = (() => {
            const first = data[0];
            if (first?.l_vals?.length === 3) {
                    const columnas = first.l_vals.map((p, i) => (`<th colspan="3" style="width: 26%">${p.serieTime.toString()}</th>`));
                return [`<th class="td-group" style="width: 22%">${t('data-lang-lbl-period')}</th>`,
                    ...columnas
                ];
            }
            return [];
        })();

        return serieTimeColumns.join("");
    };

    const getColorText = (value) => {
        let colorText = t('no-data');
        switch (value) {
            case 'r':
            colorText = t('data-lang-lbl-acelerated')
            break;
            case 'a':
            colorText = ""
            break;
            case 'v':
            colorText = ""
            break;
            default:
            colorText = t('no-data')
            break;
        }
        return colorText;
    };

    const esFechaDDMMYYYY = (str) => {
        const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
        const match = str.match(regex);
        if (!match) return false;

        const [ , dia, mes, anio ] = match;
        const fecha = new Date(`${anio}-${mes}-${dia}T00:00:00`);

        return (
            fecha.getFullYear() === parseInt(anio) &&
            fecha.getMonth() === parseInt(mes) - 1 &&
            fecha.getDate() === parseInt(dia)
        );
    };

    const getVencBG = (value) => {
        const exist = !isNullUndefinedOrEmpty(value);
        let vencBgObject = {text: t('no-data'), color: null};

        if (exist) {
            const isDate = esFechaDDMMYYYY(value);

            if (isDate) {
                const [day, month, year] = value.split('/').map(Number);
                const vencBGDate = new Date(year, month - 1, day);
                const today = new Date();

                today.setHours(0, 0, 0, 0);
                vencBGDate.setHours(0, 0, 0, 0);


                //r: vencida | a: 3 meses < vcto | v: 3meses > vcto
                const fechaInicialVencimiento = moment(cloneDeep(vencBGDate)).subtract(3, 'months').toDate();        

                vencBgObject.color = vencBGDate < today ? "red" : (today < fechaInicialVencimiento ? 'green' : 'orange');
                vencBgObject.text = value;
            }
            else {
                vencBgObject.text = value.length <= 10 ? value : value.substring(0, 10);
            }
        }

        return !isNullUndefinedOrEmpty(vencBgObject.color) ?
            `<div class="d-flex">
                <span class="dot ${!isNullUndefinedOrEmpty(vencBgObject.color) ? vencBgObject.color : ''}"></span>
                <div>${vencBgObject.text}</div>
             </div>`: `<div>${vencBgObject.text}</div>`;
    };

    const processRows = (data) => {
        const aux_data = data.map(item => ({
            ...item,
            contractualText: item.contractual === true ? t("data-lang-lbl-contractual") : t("data-lang-lbl-notcontractual"),
            
            displayValue01: item.l_vals && item.l_vals.length > 0 ? item.l_vals[0]?.displayValue : null,
            valueGoal01: item.l_vals && item.l_vals.length > 0 ? item.l_vals[0]?.valueGoal : null,
            valueGoalPercent01: item.l_vals && item.l_vals.length > 0 ? item.l_vals[0]?.valueGoalPercent : null,
            color01: item.l_vals && item.l_vals.length > 0 ? (item.l_vals[0]?.color === "r" ? 'red' : (item.l_vals[0]?.color === "a" ? 'orange' : (item.l_vals[0]?.color === "v" ? 'green' : 'unset'))) : null,

            displayValue02: item.l_vals && item.l_vals.length > 0 ? item.l_vals[1]?.displayValue : null,
            valueGoal02: item.l_vals && item.l_vals.length > 0 ? item.l_vals[1]?.valueGoal : null,
            valueGoalPercent02: item.l_vals && item.l_vals.length > 0 ? item.l_vals[1]?.valueGoalPercent : null,
            color02: item.l_vals && item.l_vals.length > 0 ? (item.l_vals[1]?.color === "r" ? 'red' : (item.l_vals[0]?.color === "a" ? 'orange' : (item.l_vals[1]?.color === "v" ? 'green' : 'unset'))) : null,

            displayValue03: item.l_vals && item.l_vals.length > 0 ? item.l_vals[2]?.displayValue : null,
            valueGoal03: item.l_vals && item.l_vals.length > 0 ? item.l_vals[2]?.valueGoal : null,
            valueGoalPercent03: item.l_vals && item.l_vals.length > 0 ? item.l_vals[2]?.valueGoalPercent : null,
            color03: item.l_vals && item.l_vals.length > 0 ? (item.l_vals[2]?.color === "r" ? 'red' : (item.l_vals[0]?.color === "a" ? 'orange' : (item.l_vals[2]?.color === "v" ? 'green' : 'unset'))) : null,

        }))
        

        const gridRowsHtml = aux_data.map(item => `<tr>
                                                        <td style="width: 22%">${item.variableName}</td>
                                                        <td style="width: 10%" class="td-num">${!isNullUndefinedOrEmpty(item.displayValue01) ? formatNumber(item.displayValue01) : t('no-data')}</td>
                                                        <td style="width: 10%" class="td-num">${!isNullUndefinedOrEmpty(item.valueGoal01) ? formatNumber(item.valueGoal01) : t('no-data')}</td>
                                                        <td style="width: 6%" class="td-logro">
                                                            <div class="d-flex td-logro">
                                                                <span class="dot ${item.color01}"></span>
                                                                <div class="td-logro">${!isNullUndefinedOrEmpty(item.valueGoalPercent01) ? formatNumber(item.valueGoalPercent01) : t('no-data')}</div>
                                                            </div>
                                                        </td>
                                                        <td style="width: 10%" class="td-num">${!isNullUndefinedOrEmpty(item.displayValue02) ? formatNumber(item.displayValue02) : t('no-data')}</td>
                                                        <td style="width: 10%" class="td-num">${!isNullUndefinedOrEmpty(item.valueGoal02) ? formatNumber(item.valueGoal02) : t('no-data')}</td>
                                                        <td style="width: 6%" class="td-logro">
                                                            <div class="d-flex td-logro">
                                                                <span class="dot ${item.color02}"></span>
                                                                <div class="td-logro">${!isNullUndefinedOrEmpty(item.valueGoalPercent02) ? formatNumber(item.valueGoalPercent02) : t('no-data')}</div>
                                                            </div>
                                                        </td>
                                                        <td style="width: 10%" class="td-num">${!isNullUndefinedOrEmpty(item.displayValue03) ? formatNumber(item.displayValue03) : t('no-data')}</td>
                                                        <td style="width: 10%" class="td-num">${!isNullUndefinedOrEmpty(item.valueGoal03) ? formatNumber(item.valueGoal03) : t('no-data')}</td>
                                                        <td style="width: 6%" class="td-logro">
                                                            <div class="d-flex td-logro">
                                                                <span class="dot ${item.color03}"></span>
                                                                <div class="td-logro">${!isNullUndefinedOrEmpty(item.valueGoalPercent03) ? formatNumber(item.valueGoalPercent03) : t('no-data')}</div>
                                                            </div>
                                                        </td>
                                                    </tr>`)

        return gridRowsHtml.join("");
    };

    const processRoleRows = (data) => {       
        const gridRowsHtml = data.map(item => `<tr>
                                                <td style="width: 25%">${!isNullUndefinedOrEmpty(item.rol) ? item.rol : t('no-data')}</td>
                                                <td style="width: 75%" class="td-num">${!isNullUndefinedOrEmpty(item.usernames) ? item.usernames : t('no-data')}</td>
                                            </tr>`)

        return gridRowsHtml.join("");
    };

    const processContractRows = (data) => {       
        const gridRowsHtml = `<tr>
                                    <td class="text-c" style="width: 20%">${!isNullUndefinedOrEmpty(clientName) ? clientName : t('no-data')}</td>
                                    <td class="text-c" style="width: 13%">${!isNullUndefinedOrEmpty(data[0].bu) ? data[0].bu : t('no-data')}</td>
                                    <td class="text-c" style="width: 13%">${!isNullUndefinedOrEmpty(data[0].contractCode) ? data[0].contractCode : t('no-data')}</td>
                                    <td class="text-c" style="width: 24%">${!isNullUndefinedOrEmpty(data[0].name) ? data[0].name : t('no-data')}</td>
                                    <td class="text-c" style="width: 20%">${!isNullUndefinedOrEmpty(data[0].eecc) ? data[0].eecc : t('no-data')}</td>
                                    <td class="text-c" style="width: 10%">${!isNullUndefinedOrEmpty(data[0].nRevisions) ? data[0].nRevisions : t('no-data')}</td>
                                </tr>`

        const gridRolesRowsHtml = data[0].l_roles.map(item => (`<tr>
                                    <td>${item.role}</td>
                                    <td colspan="3">${item.firstname} ${item.lastname}</td>
                                </tr>`))

        return (gridRowsHtml + gridRolesRowsHtml.join(""));
    };

    const PDFReport = ({ chartUris, singleRecordHtmlTop, singleRecordHtmlBottom, gridRecordsHtml, data_roles, data_contract, data_contract_name}) => {
        
        const Footer = () => (
            <View style={styles.footer} fixed>
                <Text>{`${t('data-lang-lbl-generated')} ${new Date().toLocaleDateString()}`}</Text>
            </View>
        )

        return (
            <Document>
                <Page size="A4" orientation="landscape" style={styles.page}>
                    {/* Sección: Título */}
                    <View style={styles.rowTitle}>
                        <Text style={styles.h2}>{ t('data-lang-lbl-contract') } </Text>
                    </View>
                    <View style={styles.rowTitle}>
                        <Text style={styles.title}>{ data_contract_name } </Text>
                    </View>

                    {/* Sección: Información del contrato */}
                    <View style={styles.row}>
                        <View style={{ marginTop: 8 }}>
                            <Text style={styles.h1}>{t('data-lang-boxname-contractinformation')}:</Text>
                        </View>
                    </View>
                    <View style={styles.row}>
                        {data_contract && (
                            <View style={{ marginTop: 8 }}>
                                <Html stylesheet={pdfStyles} >
                                    {data_contract}
                                </Html>
                            </View>
                        )}
                    </View>

                    {/* Sección: Registro único 1 */}
                    <View style={styles.row}>
                        {singleRecordHtmlTop && (
                            <View style={{ marginTop: 8 }}>
                                <Html stylesheet={pdfStyles} >
                                    {singleRecordHtmlTop}
                                </Html>
                            </View>
                        )}
                    </View>

                    {/* Sección: Registro único 2 */}
                    <View style={styles.row}>
                        {singleRecordHtmlBottom && (
                            <View style={{ marginTop: 8 }}>
                                <Html stylesheet={pdfStyles} >
                                    {singleRecordHtmlBottom}
                                </Html>
                            </View>
                        )}
                    </View>

                    {/* Sección: Charts */}
                    <View style={stylesChart.chartsRow}>
                        {
                            chartUris && chartUris.map((chartUri) => (
                                <View style={stylesChart.chartCol}>
                                    <Text style={stylesChart.chartTitle}>{chartUri.name}</Text>
                                    <PdfImage src={chartUri.imgURI} style={stylesChart.chartImage} />
                                </View>
                            ))
                        }
                    </View>

                    <Footer />
                </Page>
                <Page size="A4" orientation="landscape" style={styles.page}>
                    {/* Sección: Grilla como tabla */}
                    <View style={styles.row}>
                        <View style={{ marginTop: 8 }}>
                            <Text style={styles.h1}>{t('data-lang-lbl-kpikeys')}:</Text>
                        </View>
                    </View>
                    <View style={styles.row}>
                        {gridRecordsHtml && (
                            <View style={{ marginTop: 8 }}>
                                <Html stylesheet={pdfStyles}>
                                    {gridRecordsHtml}
                                </Html>
                            </View>
                        )}
                    </View>

                    <Footer />
                </Page>
                <Page size="A4" orientation="landscape" style={styles.page}>
                    {/* Sección: Información del contrato */}
                    <View style={styles.row}>
                        <View style={{ marginTop: 8 }}>
                            <Text style={styles.h1}>{t('data-lang-lbl-roles')}:</Text>
                        </View>
                    </View>
                    <View style={styles.row}>
                        {data_roles && (
                            <View style={{ marginTop: 8 }}>
                                <Html stylesheet={pdfStyles} >
                                    {data_roles}
                                </Html>
                            </View>
                        )}
                    </View>

                    <Footer />
                </Page>
            </Document>
        );
    };

    try {
        const singleRecordHtml1 = `<table class="single-record">
                                <thead>
                                    <tr class="text-center align-middle">
                                        <th style="width: 14%">${t('data-lang-lbl-adminusername')}</th>
                                        <th style="width: 14%">${t('data-lang-lbl-contracting')}</th>
                                        <th style="width: 13%">${t('data-lang-lbl-monthsegmentation')}</th>
                                        <th style="width: 17%">${t('data-lang-lbl-contractamount')}</th>
                                        <th style="width: 17%">${t('data-lang-lbl-exchangerate')}</th>
                                        <th style="width: 8%" >${t('data-lang-lbl-startdate')}</th>
                                        <th style="width: 8%" >${t('data-lang-lbl-termdate')}</th>
                                        <th style="width: 9%" >${t('data-lang-lbl-contractterm')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="text-center align-middle">
                                        <td class="text-c" style="width: 14%"><span>${!isNullUndefinedOrEmpty(singleRecord.adminUsername) ? singleRecord.adminUsername : t('no-data')}</span></td>
                                        <td class="text-c" style="width: 14%"><span>${!isNullUndefinedOrEmpty(singleRecord.l_props.find(prop => prop.shortName === 'gst')) ? singleRecord.l_props.find(prop => prop.shortName === 'gst').strVal : t('no-data')}</span></td>
                                        <td class="text-c" style="width: 13%"><span>${!isNullUndefinedOrEmpty(singleRecord.segmentName) ? singleRecord.segmentName : t('no-data')}</span></td>
                                        <td class="text-c" style="width: 17%"><span>${!isNullUndefinedOrEmpty(singleRecord.amount) ? formatNumber(singleRecord.amount) : t('no-data')}</span></td>
                                        <td class="text-c" style="width: 17%"><span>${!isNullUndefinedOrEmpty(singleRecord.exchangeRate) ? singleRecord.exchangeRate : t('no-data')}</span></td>
                                        <td class="text-c" style="width: 8%" ><span>${!isNullUndefinedOrEmpty(singleRecord.startDate) ? moment(singleRecord.startDate).format('DD/MM/YYYY') : t('no-data')}</span></td>
                                        <td class="text-c" style="width: 8%" ><span>${!isNullUndefinedOrEmpty(singleRecord.endDate) ? moment(singleRecord.endDate).format('DD/MM/YYYY') : t('no-data')}</span></td>
                                        <td class="text-c" style="width: 9%" ><span>${!isNullUndefinedOrEmpty(singleRecord.nMesesContrato) ? singleRecord.nMesesContrato : t('no-data')}</span></td>
                                    </tr>
                                </tbody>
                                   </table>`

        const singleRecordHtml2 = `<table class="single-record secondary">
                                    <thead>
                                        <tr class="text-center align-middle">
                                            <th style="width: 25%">${t('data-lang-lbl-aceleration')}</th>
                                            <th style="width: 25%">${t('data-lang-lbl-physicalprogress')}</th>
                                            <th style="width: 25%">${t('data-lang-lbl-financialprogress')}</th>
                                            <th style="width: 25%">${t('data-lang-lbl-vencbg')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="text-center align-middle">
                                            <td class="text-r">
                                                <div class="d-flex text-r">
                                                    <span class="text-r dot ${!isNullUndefined(singleRecord.l_gastos.find(x => x.key === "MTACEGASTO")) ? singleRecord.l_gastos.find(x => x.key === "MTACEGASTO").item.color : '' }"></span>
                                                    <div>${!isNullUndefined(singleRecord.l_gastos.find(x => x.key === "MTACEGASTO")) ? `${ getColorText(singleRecord.l_gastos.find(x => x.key === "MTACEGASTO").item.color) }` : t('no-data')}</div>
                                                </div>
                                            </td>
                                            <td class="text-c"><span>${!isNullUndefined(singleRecord.l_gastos.find(x => x.key === "MTAVANFISICO")) ? `${formatNumber(singleRecord.l_gastos.find(x => x.key === "MTAVANFISICO").item.valueGoalPercent)}%` : t('no-data')}</span></td>
                                            <td class="text-c"><span>${!isNullUndefined(singleRecord.l_gastos.find(x => x.key === "MTAVANFINAN")) ? `${formatNumber(singleRecord.l_gastos.find(x => x.key === "MTAVANFINAN").item.valueGoalPercent)}%` : t('no-data')}</span></td>
                                            <td class="text-c"><span>${!isNullUndefined(singleRecord.l_props.find(x => x.shortName.toLocaleString() === "boleta")) ? getVencBG(singleRecord.l_props.find(x => x.shortName.toLocaleString() === "boleta").strVal) : t('no-data')}</span></td>
                                        </tr>
                                    </tbody>
                                   </table>`

        const gridRecordsHtml = `<table class="grid-kpi">
                                    <thead>
                                        <tr>
                                            ${getColumngroups(gridRows)}
                                        </tr>
                                        <tr>
                                            <th style="width: 22%">${t('data-lang-lbl-kpiclass')}</th>
                                            <th style="width: 10%">${t('data-lang-lbl-field-realvalue')}</th>
                                            <th style="width: 10%">${t('data-lang-lbl-goal')}</th>
                                            <th style="width: 6%">${t('data-lang-lbl-goalpercent')}</th>

                                            <th style="width: 10%">${t('data-lang-lbl-field-realvalue')}</th>
                                            <th style="width: 10%">${t('data-lang-lbl-goal')}</th>
                                            <th style="width: 6%">${t('data-lang-lbl-goalpercent')}</th>

                                            <th style="width: 10%">${t('data-lang-lbl-field-realvalue')}</th>
                                            <th style="width: 10%">${t('data-lang-lbl-goal')}</th>
                                            <th style="width: 6%">${t('data-lang-lbl-goalpercent')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>${processRows(gridRows)}</tbody>
                                 </table>`

        const gridRoles = `<table class="single-record">
                                    <thead>
                                        <tr class="text-center align-middle">
                                            <th style="width: 25%">${t('data-lang-lbl-role')}</th>
                                            <th style="width: 75%">${t('data-lang-lbl-name')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        ${processRoleRows(data_roles)}
                                    </tbody>
                           </table>` 
                                            
        const gridContractProps = `<table class="single-record">
                                        <thead>
                                            <tr class="text-center align-middle">
                                                <th style="width: 20%">${t('data-lang-lbl-client')}</th>
                                                <th style="width: 13%">${t('data-lang-lbl-businessunit')}</th>
                                                <th style="width: 13%">${t('data-lang-lbl-contractcode')}</th>
                                                <th style="width: 24%">${t('data-lang-lbl-contractname')}</th>
                                                <th style="width: 20%">${t('data-lang-lbl-eecc')}</th>
                                                <th style="width: 10%">${t('data-lang-boxname-revisions')}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            ${processContractRows(data_contract)}
                                        </tbody>
                                   </table>`  

        const doc = (
            <PDFReport
                chartUris={chartUris}
                singleRecordHtmlTop={singleRecordHtml1}
                singleRecordHtmlBottom={singleRecordHtml2}
                gridRecordsHtml={gridRecordsHtml}
                data_roles={gridRoles}
                data_contract={gridContractProps}
                data_contract_name={!isNullUndefinedOrEmpty(data_contract) && data_contract.length > 0 ? data_contract[0]?.name: ''}
            />
        );

        const blob = await pdf(doc).toBlob();
        saveAs(blob, `${t('data-lang-pagename-powerbi')}${!isNullUndefinedOrEmpty(data_contract) && data_contract.length > 0 ? ` - ${data_contract[0].contractCode}` : ""}.pdf`);
    } catch (error) {
        console.log(error)
    }
}